import { makeStyles, FormControlLabel, Switch } from '@paintscout/ui'
import React from 'react'
import { useCalendar } from '../Calendar'

const useStyles = makeStyles((theme) => ({
  switch: {
    color: theme.palette.text.secondary,
    paddingRight: theme.spacing(0.5)
  }
}))

export default function ShowWeekendsSwitch() {
  const classes = useStyles()
  const { hideWeekends, setHideWeekends, view } = useCalendar()

  const handleSetWeekends = (value: boolean) => {
    localStorage.setItem('calendarHideWeekends', value ? 'false' : 'true')
    setHideWeekends(value)
  }

  if (view === 'day') {
    return null
  }

  return (
    <FormControlLabel
      className={classes.switch}
      label="Weekends"
      labelPlacement="start"
      control={<Switch checked={!hideWeekends} onChange={() => handleSetWeekends(!hideWeekends)} />}
    />
  )
}
